import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentoRepositorioService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'documento-repositorio');
  }

  getArquivos(documentoId: number): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/${documentoId}/arquivos`);
  }

  uploadArquivo(documentoId: number, arquivo: File, descricao?: string): Observable<any> {
    const formData = new FormData();
    formData.append('arquivo', arquivo);

    if (descricao?.trim()) {
      formData.append('descricao', descricao.trim());
    }

    return this.http.post(`${this.url_base}/${this.prefixo}/${documentoId}/arquivos`, formData);
  }
}
